// extracted by mini-css-extract-plugin
module.exports = {"button":"ComptabiliteToolbar_button__2kvOz"};